module.exports = __webpack_public_path__ + "static/media/border-inner.25c67692.svg";